import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@klareospace/pharos-lib-web-utils';
import { DASHBOARD_TAB, Dashboard, type DashboardTab } from '&/features/dashboard';
import { useDriverKpisMonth, useDriverKpisToday, useOrderKpisMonth, useOrderKpisToday } from '&/features/kpis';
import { MainSelector } from '&/features/main-selector';

function HomePage(): React.JSX.Element {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState<DashboardTab>(DASHBOARD_TAB.TODAY);
  const isTodayTabActive = activeTab === DASHBOARD_TAB.TODAY;
  const kpis = useOrderKpisToday({ heartbeat: isTodayTabActive });
  const driverKpis = useDriverKpisToday({ heartbeat: isTodayTabActive });
  const isMonthTabActive = activeTab === DASHBOARD_TAB.MONTH;
  const monthOrderKpis = useOrderKpisMonth({ enabled: isMonthTabActive });
  const monthDriverKpis = useDriverKpisMonth({ enabled: isMonthTabActive });

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <PageHeader
        breadcrumb={<MainSelector />}
        description={t('pages.home.subtitle')}
        title={t('pages.home.title')}
        variant="banner"
      />
      {kpis.isEnabled && (
        <Dashboard
          activeTab={activeTab}
          driverKpis={driverKpis}
          kpis={kpis}
          monthDriverKpis={monthDriverKpis}
          monthOrderKpis={monthOrderKpis}
          onActiveTabChange={setActiveTab}
        />
      )}
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/')({
  component: HomePage,
});
